import { observer } from "mobx-react-lite";
import { useStore } from "../../../../stores";
import { ChatChannel } from "../../../../models";
import { useState } from "react";
import { Modal } from "../../../../components";
import { NewCallDialPad } from "../../../../components/twilioVoiceCallProvider/modals/VoiceCallModal";

const DialVoiceCall = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { selectedBot } = useStore("bots");
  const { selectedChat } = useStore("chats");

  if (
    !selectedBot?.settings?.voiceCallEnabled ||
    ![ChatChannel.TwilioWhatsApp, ChatChannel.MetaWhatsApp].includes(
      selectedChat?.channel!
    )
  ) {
    return null;
  }

  return (
    <>
      <button
        className="button is-rounded has-text-primary"
        onClick={() => setIsOpen(true)}
      >
        <span style={{ position: "absolute" }} className="icon">
          <img src="/assets/voice-call-icon.svg" alt="" width={16} />
        </span>
      </button>
      {isOpen && (
        <Modal
          isOpen
          title={() => (
            <div className="is-align-items-center is-flex is-justify-content-space-between w-100">
              <h2 className="title is-5 mb-0">Dial Pad</h2>
            </div>
          )}
          onClose={() => setIsOpen(false)}
        >
          <NewCallDialPad
            defaultNumber={selectedChat?.senderId}
            onClosed={() => setIsOpen(false)}
          />
        </Modal>
      )}
    </>
  );
};

export default observer(DialVoiceCall);
